
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2075.739-1769.043h13.487a.893.893 0 00.659-.287.928.928 0 00.278-.674.912.912 0 00-.278-.669.9.9 0 00-.659-.278h-13.487a.917.917 0 00-.664.278.9.9 0 00-.283.669.92.92 0 00.284.674.909.909 0 00.663.287zm6.748 6.729a.9.9 0 00.664-.278.92.92 0 00.273-.669v-13.477a.925.925 0 00-.273-.664.889.889 0 00-.664-.283.959.959 0 00-.957.947v13.476a.912.912 0 00.278.669.924.924 0 00.68.279z"}})])])
          )
        }
      }
    